// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_models__Locale from "../../models/Locale.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";

function toString(route) {
  if (/* tag */ typeof route === "number" || typeof route === "string") {
    if (route === /* NotFound */ 0) {
      return "/";
    } else {
      return "/app";
    }
  }
  if (route.TAG === /* Landing */ 0) {
    const landing = route._2;
    const countryStr = Buhta_models__Locale.toCountryString(route._0);
    const languageStr = Buhta_models__Locale.toString(route._1);
    let routeStr;
    if (/* tag */ typeof landing === "number" || typeof landing === "string") {
      switch (landing) {
        case /* Home */ 0 :
          routeStr = "";
          break;
        case /* Tis */ 1 :
          routeStr = "/tis";
          break;
        case /* Outsourcing */ 2 :
          routeStr = "/solutions/outsourcing";
          break;
        case /* About */ 3 :
          routeStr = "/about";
          break;
        case /* Partners */ 4 :
          routeStr = "/partners";
          break;
        case /* Pricing */ 5 :
          routeStr = "/pricing";
          break;
        case /* ContactForm */ 6 :
          routeStr = "/pricing/contact-form";
          break;
        case /* Contact */ 7 :
          routeStr = "/contact";
          break;
        case /* CompanyDetails */ 8 :
          routeStr = "/company-details";
          break;
        case /* Jobs */ 9 :
          routeStr = "/jobs";
          break;
        case /* Awards */ 10 :
          routeStr = "/awards";
          break;
        case /* Licenses */ 11 :
          routeStr = "/licenses";
          break;
        case /* Security */ 12 :
          routeStr = "/security";
          break;
        case /* Kassa */ 13 :
          routeStr = "/features/kassa";
          break;
        case /* TaxReporting */ 14 :
          routeStr = "/features/tax/reporting";
          break;
        case /* ESF */ 15 :
          routeStr = "/features/esf";
          break;
        case /* Payroll */ 16 :
          routeStr = "/features/payroll";
          break;
        case /* Finance */ 17 :
          routeStr = "/features/finance";
          break;
        case /* FAQ */ 18 :
          routeStr = "/faq";
          break;
      }
    } else {
      switch (landing.TAG) {
        case /* Job */ 0 :
          routeStr = "/jobs/" + landing._0;
          break;
        case /* Blog */ 1 :
          const pageNum = landing._0;
          routeStr = pageNum > 0 ? "/blog/" + String(pageNum) : "/blog";
          break;
        case /* BlogPost */ 2 :
          routeStr = "/blog/post/" + landing._0;
          break;
        case /* BlogSection */ 3 :
          const pageNum$1 = landing._1;
          const slug = landing._0;
          routeStr = pageNum$1 > 0 ? "/blog/section/" + slug + "/" + String(pageNum$1) : "/blog/section/" + slug;
          break;
        case /* Library */ 4 :
          const pageNum$2 = landing._0;
          routeStr = pageNum$2 > 0 ? "/library/" + String(pageNum$2) : "/library";
          break;
        case /* LibrarySection */ 5 :
          const pageNum$3 = landing._1;
          const slug$1 = landing._0;
          routeStr = pageNum$3 > 0 ? "/library/section/" + slug$1 + "/" + String(pageNum$3) : "/library/section/" + slug$1;
          break;
        case /* LibraryArticle */ 6 :
          routeStr = "/library/article/" + landing._0;
          break;
        case /* Legal */ 7 :
          switch (landing._0) {
            case /* Privacy */ 0 :
              routeStr = "/legal/privacy";
              break;
            case /* Agreement */ 1 :
              routeStr = "/legal/agreement";
              break;
            case /* Consent */ 2 :
              routeStr = "/legal/consent";
              break;
            case /* Security */ 3 :
              routeStr = "/legal/security";
              break;
          }
          break;
        case /* Classifiers */ 8 :
          const match = landing._0;
          if (/* tag */ typeof match === "number" || typeof match === "string") {
            routeStr = "/classifiers";
          } else {
            switch (match.TAG) {
              case /* Kogd */ 0 :
                const id = match._0;
                routeStr = /* tag */ typeof id === "number" || typeof id === "string" ? "/classifiers/kogd" : "/classifiers/kogd/" + id._0;
                break;
              case /* Kbk */ 1 :
                const id$1 = match._0;
                routeStr = /* tag */ typeof id$1 === "number" || typeof id$1 === "string" ? "/classifiers/kbk" : "/classifiers/kbk/" + id$1._0;
                break;
              case /* Bank */ 2 :
                const id$2 = match._0;
                routeStr = /* tag */ typeof id$2 === "number" || typeof id$2 === "string" ? "/classifiers/banks" : "/classifiers/banks/" + id$2._0;
                break;
              case /* Unit */ 3 :
                const id$3 = match._0;
                routeStr = /* tag */ typeof id$3 === "number" || typeof id$3 === "string" ? "/classifiers/units" : "/classifiers/units/" + id$3._0;
                break;
            }
          }
          break;
      }
    }
    return "/" + countryStr + "/" + languageStr + routeStr;
  }
  const countryStr$1 = Buhta_models__Locale.toCountryString(route._0);
  const languageStr$1 = Buhta_models__Locale.toString(route._1);
  let docsStr;
  switch (route._2) {
    case /* Home */ 0 :
      docsStr = "";
      break;
    case /* Kassa */ 1 :
      docsStr = "/kassa";
      break;
    case /* Post */ 2 :
      docsStr = "/post";
      break;
  }
  return "/" + countryStr$1 + "/" + languageStr$1 + "/docs" + docsStr;
}

function getLanguageRoute(country, language, path) {
  if (!path) {
    return {
      TAG: /* Landing */ 0,
      _0: country,
      _1: language,
      _2: /* Home */ 0
    };
  }
  switch (path.hd) {
    case "" :
      if (path.tl) {
        return /* NotFound */ 0;
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Home */ 0
        };
      }
    case "about" :
      if (path.tl) {
        return /* NotFound */ 0;
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* About */ 3
        };
      }
    case "awards" :
      if (path.tl) {
        return /* NotFound */ 0;
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Awards */ 10
        };
      }
    case "blog" :
      const match = path.tl;
      if (!match) {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: {
            TAG: /* Blog */ 1,
            _0: 0
          }
        };
      }
      const pageNum = match.hd;
      if (match.tl) {
        switch (pageNum) {
          case "post" :
            const match$1 = match.tl;
            if (match$1.tl) {
              return /* NotFound */ 0;
            } else {
              return {
                TAG: /* Landing */ 0,
                _0: country,
                _1: language,
                _2: {
                  TAG: /* BlogPost */ 2,
                  _0: match$1.hd
                }
              };
            }
          case "section" :
            const match$2 = match.tl;
            const match$3 = match$2.tl;
            const slug = match$2.hd;
            if (match$3) {
              if (match$3.tl) {
                return /* NotFound */ 0;
              } else {
                return {
                  TAG: /* Landing */ 0,
                  _0: country,
                  _1: language,
                  _2: {
                    TAG: /* BlogSection */ 3,
                    _0: slug,
                    _1: Caml_format.caml_int_of_string(match$3.hd)
                  }
                };
              }
            } else {
              return {
                TAG: /* Landing */ 0,
                _0: country,
                _1: language,
                _2: {
                  TAG: /* BlogSection */ 3,
                  _0: slug,
                  _1: 0
                }
              };
            }
          default:
            return /* NotFound */ 0;
        }
      } else {
        let tmp;
        try {
          tmp = Caml_format.caml_int_of_string(pageNum);
        }
        catch (exn){
          tmp = 0;
        }
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: {
            TAG: /* Blog */ 1,
            _0: tmp
          }
        };
      }
    case "classifiers" :
      const match$4 = path.tl;
      if (!match$4) {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: {
            TAG: /* Classifiers */ 8,
            _0: /* List */ 0
          }
        };
      }
      switch (match$4.hd) {
        case "banks" :
          const match$5 = match$4.tl;
          if (match$5) {
            if (match$5.tl) {
              return /* NotFound */ 0;
            } else {
              return {
                TAG: /* Landing */ 0,
                _0: country,
                _1: language,
                _2: {
                  TAG: /* Classifiers */ 8,
                  _0: {
                    TAG: /* Bank */ 2,
                    _0: {
                      TAG: /* View */ 0,
                      _0: match$5.hd
                    }
                  }
                }
              };
            }
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: {
                TAG: /* Classifiers */ 8,
                _0: {
                  TAG: /* Bank */ 2,
                  _0: /* List */ 0
                }
              }
            };
          }
        case "kbk" :
          const match$6 = match$4.tl;
          if (match$6) {
            if (match$6.tl) {
              return /* NotFound */ 0;
            } else {
              return {
                TAG: /* Landing */ 0,
                _0: country,
                _1: language,
                _2: {
                  TAG: /* Classifiers */ 8,
                  _0: {
                    TAG: /* Kbk */ 1,
                    _0: {
                      TAG: /* View */ 0,
                      _0: match$6.hd
                    }
                  }
                }
              };
            }
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: {
                TAG: /* Classifiers */ 8,
                _0: {
                  TAG: /* Kbk */ 1,
                  _0: /* List */ 0
                }
              }
            };
          }
        case "kogd" :
          const match$7 = match$4.tl;
          if (match$7) {
            if (match$7.tl) {
              return /* NotFound */ 0;
            } else {
              return {
                TAG: /* Landing */ 0,
                _0: country,
                _1: language,
                _2: {
                  TAG: /* Classifiers */ 8,
                  _0: {
                    TAG: /* Kogd */ 0,
                    _0: {
                      TAG: /* View */ 0,
                      _0: match$7.hd
                    }
                  }
                }
              };
            }
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: {
                TAG: /* Classifiers */ 8,
                _0: {
                  TAG: /* Kogd */ 0,
                  _0: /* List */ 0
                }
              }
            };
          }
        case "units" :
          const match$8 = match$4.tl;
          if (match$8) {
            if (match$8.tl) {
              return /* NotFound */ 0;
            } else {
              return {
                TAG: /* Landing */ 0,
                _0: country,
                _1: language,
                _2: {
                  TAG: /* Classifiers */ 8,
                  _0: {
                    TAG: /* Unit */ 3,
                    _0: {
                      TAG: /* View */ 0,
                      _0: match$8.hd
                    }
                  }
                }
              };
            }
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: {
                TAG: /* Classifiers */ 8,
                _0: {
                  TAG: /* Unit */ 3,
                  _0: /* List */ 0
                }
              }
            };
          }
        default:
          return /* NotFound */ 0;
      }
    case "company-details" :
      if (path.tl) {
        return /* NotFound */ 0;
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* CompanyDetails */ 8
        };
      }
    case "contact" :
      if (path.tl) {
        return /* NotFound */ 0;
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Contact */ 7
        };
      }
    case "docs" :
      const match$9 = path.tl;
      if (!match$9) {
        return {
          TAG: /* Docs */ 1,
          _0: country,
          _1: language,
          _2: /* Home */ 0
        };
      }
      switch (match$9.hd) {
        case "kassa" :
          if (match$9.tl) {
            return /* NotFound */ 0;
          } else {
            return {
              TAG: /* Docs */ 1,
              _0: country,
              _1: language,
              _2: /* Kassa */ 1
            };
          }
        case "post" :
          if (match$9.tl) {
            return /* NotFound */ 0;
          } else {
            return {
              TAG: /* Docs */ 1,
              _0: country,
              _1: language,
              _2: /* Post */ 2
            };
          }
        default:
          return /* NotFound */ 0;
      }
    case "faq" :
      if (path.tl) {
        return /* NotFound */ 0;
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* FAQ */ 18
        };
      }
    case "features" :
      const match$10 = path.tl;
      if (!match$10) {
        return /* NotFound */ 0;
      }
      switch (match$10.hd) {
        case "esf" :
          if (match$10.tl) {
            return /* NotFound */ 0;
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: /* ESF */ 15
            };
          }
        case "finance" :
          if (match$10.tl) {
            return /* NotFound */ 0;
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: /* Finance */ 17
            };
          }
        case "kassa" :
          if (match$10.tl) {
            return /* NotFound */ 0;
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: /* Kassa */ 13
            };
          }
        case "payroll" :
          if (match$10.tl) {
            return /* NotFound */ 0;
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: /* Payroll */ 16
            };
          }
        case "tax" :
          const match$11 = match$10.tl;
          if (match$11 && match$11.hd === "reporting" && !match$11.tl) {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: /* TaxReporting */ 14
            };
          } else {
            return /* NotFound */ 0;
          }
        default:
          return /* NotFound */ 0;
      }
    case "jobs" :
      const match$12 = path.tl;
      if (match$12) {
        if (match$12.tl) {
          return /* NotFound */ 0;
        } else {
          return {
            TAG: /* Landing */ 0,
            _0: country,
            _1: language,
            _2: {
              TAG: /* Job */ 0,
              _0: match$12.hd
            }
          };
        }
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Jobs */ 9
        };
      }
    case "legal" :
      const match$13 = path.tl;
      if (!match$13) {
        return /* NotFound */ 0;
      }
      switch (match$13.hd) {
        case "agreement" :
          if (match$13.tl) {
            return /* NotFound */ 0;
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: {
                TAG: /* Legal */ 7,
                _0: /* Agreement */ 1
              }
            };
          }
        case "consent" :
          if (match$13.tl) {
            return /* NotFound */ 0;
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: {
                TAG: /* Legal */ 7,
                _0: /* Consent */ 2
              }
            };
          }
        case "privacy" :
          if (match$13.tl) {
            return /* NotFound */ 0;
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: {
                TAG: /* Legal */ 7,
                _0: /* Privacy */ 0
              }
            };
          }
        case "security" :
          if (match$13.tl) {
            return /* NotFound */ 0;
          } else {
            return {
              TAG: /* Landing */ 0,
              _0: country,
              _1: language,
              _2: {
                TAG: /* Legal */ 7,
                _0: /* Security */ 3
              }
            };
          }
        default:
          return /* NotFound */ 0;
      }
    case "library" :
      const match$14 = path.tl;
      if (!match$14) {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: {
            TAG: /* Library */ 4,
            _0: 0
          }
        };
      }
      const pageNum$1 = match$14.hd;
      if (match$14.tl) {
        switch (pageNum$1) {
          case "article" :
            const match$15 = match$14.tl;
            if (match$15.tl) {
              return /* NotFound */ 0;
            } else {
              return {
                TAG: /* Landing */ 0,
                _0: country,
                _1: language,
                _2: {
                  TAG: /* LibraryArticle */ 6,
                  _0: match$15.hd
                }
              };
            }
          case "section" :
            const match$16 = match$14.tl;
            const match$17 = match$16.tl;
            const slug$1 = match$16.hd;
            if (match$17) {
              if (match$17.tl) {
                return /* NotFound */ 0;
              } else {
                return {
                  TAG: /* Landing */ 0,
                  _0: country,
                  _1: language,
                  _2: {
                    TAG: /* LibrarySection */ 5,
                    _0: slug$1,
                    _1: Caml_format.caml_int_of_string(match$17.hd)
                  }
                };
              }
            } else {
              return {
                TAG: /* Landing */ 0,
                _0: country,
                _1: language,
                _2: {
                  TAG: /* LibrarySection */ 5,
                  _0: slug$1,
                  _1: 0
                }
              };
            }
          default:
            return /* NotFound */ 0;
        }
      } else {
        let tmp$1;
        try {
          tmp$1 = Caml_format.caml_int_of_string(pageNum$1);
        }
        catch (exn$1){
          tmp$1 = 0;
        }
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: {
            TAG: /* Library */ 4,
            _0: tmp$1
          }
        };
      }
    case "licenses" :
      if (path.tl) {
        return /* NotFound */ 0;
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Licenses */ 11
        };
      }
    case "partners" :
      if (path.tl) {
        return /* NotFound */ 0;
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Partners */ 4
        };
      }
    case "pricing" :
      const match$18 = path.tl;
      if (match$18) {
        if (match$18.hd === "contact-form" && !match$18.tl) {
          return {
            TAG: /* Landing */ 0,
            _0: country,
            _1: language,
            _2: /* ContactForm */ 6
          };
        } else {
          return /* NotFound */ 0;
        }
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Pricing */ 5
        };
      }
    case "security" :
      if (path.tl) {
        return /* NotFound */ 0;
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Security */ 12
        };
      }
    case "solutions" :
      const match$19 = path.tl;
      if (match$19 && match$19.hd === "outsourcing" && !match$19.tl) {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Outsourcing */ 2
        };
      } else {
        return /* NotFound */ 0;
      }
    case "tis" :
      if (path.tl) {
        return /* NotFound */ 0;
      } else {
        return {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Tis */ 1
        };
      }
    default:
      return /* NotFound */ 0;
  }
}

function getLocalRoute(country, path) {
  if (!path) {
    return {
      TAG: /* Landing */ 0,
      _0: country,
      _1: /* Ru */ 1,
      _2: /* Home */ 0
    };
  }
  switch (path.hd) {
    case "en" :
      return getLanguageRoute(country, /* En */ 0, path.tl);
    case "kk" :
      return getLanguageRoute(country, /* Kk */ 2, path.tl);
    case "ru" :
      return getLanguageRoute(country, /* Ru */ 1, path.tl);
    case "uz" :
      return getLanguageRoute(country, /* Uz */ 3, path.tl);
    default:
      return getLanguageRoute(country, /* Ru */ 1, path);
  }
}

function ofUrl(url) {
  const rest = url.path;
  if (!rest) {
    return getLocalRoute(/* COUNTRY_KAZ */ 1, rest);
  }
  switch (rest.hd) {
    case "app" :
      if (rest.tl) {
        return getLocalRoute(/* COUNTRY_KAZ */ 1, rest);
      } else {
        return /* App */ 1;
      }
    case "kg" :
      return getLocalRoute(/* COUNTRY_KGZ */ 2, rest.tl);
    case "kz" :
      return getLocalRoute(/* COUNTRY_KAZ */ 1, rest.tl);
    case "uz" :
      return getLocalRoute(/* COUNTRY_UZB */ 3, rest.tl);
    default:
      return getLocalRoute(/* COUNTRY_KAZ */ 1, rest);
  }
}

function isOrgOrAdminRoute(url) {
  const match = url.path;
  if (!match) {
    return false;
  }
  switch (match.hd) {
    case "admin" :
    case "org" :
      return true;
    default:
      return false;
  }
}

function navigateTo(page) {
  ReasonReactRouter.push(toString(page));
}

function updateBrowserLocation(url) {
  const title = document.title;
  window.history.pushState(window.history.state, title, url);
}

function urlWithParams(url, params) {
  const url$1 = toString(url);
  const params$1 = Belt__Belt_List.toArray(Belt__Belt_List.map(params, (function (param) {
    return param[0] + ("=" + param[1]);
  }))).join("&");
  return url$1 + ("?" + params$1);
}

function setUrlParams(params) {
  const url = window.location.href.replace(window.location.search, "");
  const params$1 = Belt__Belt_List.toArray(Belt__Belt_List.map(params, (function (param) {
    return param[0] + ("=" + param[1]);
  }))).join("&");
  ReasonReactRouter.push(url + ("?" + params$1));
}

function getParamValue(url, param, param$1) {
  const searchParams = new URLSearchParams(url.search);
  return Caml_option.nullable_to_opt(searchParams.get(param));
}

function useParamValue(url, paramName) {
  const match = React.useState(function () {
    return getParamValue(url, paramName, undefined);
  });
  const setValue = match[1];
  const handleValueChange = function (value) {
    const searchParams = new URLSearchParams(window.location.search);
    const keys = Belt__Belt_List.fromArray(Array.from(searchParams.keys()));
    const params = Belt__Belt_List.keepMap(keys, (function (key) {
      if (key === paramName) {
        return;
      }
      const value = getParamValue(url, key, undefined);
      if (value !== undefined) {
        return [
          key,
          value
        ];
      }
      
    }));
    const params$1 = value !== undefined ? Stdlib.$at(params, {
        hd: [
          paramName,
          value
        ],
        tl: /* [] */ 0
      }) : params;
    setUrlParams(params$1);
    Curry._1(setValue, (function (param) {
      return value;
    }));
  };
  return [
    match[0],
    handleValueChange
  ];
}

function dispatchPopStateEvent(param) {
  window.dispatchEvent(new Event("popState"));
}

export {
  toString,
  getLanguageRoute,
  getLocalRoute,
  ofUrl,
  isOrgOrAdminRoute,
  navigateTo,
  updateBrowserLocation,
  urlWithParams,
  setUrlParams,
  getParamValue,
  useParamValue,
  dispatchPopStateEvent,
}
/* Buhta_models__Locale Not a pure module */
